<template>
  <div class="container-fluid px-0">
    <div class="row mb-4 g-2">
      <!-- Date Filter -->
      <div class="col-6 col-md-2 col-lg-2">
        <input 
          type="date" 
          class="form-control form-control-sm" 
          v-model="filters.date"
          @change="applyFilters"
        >
      </div>
      
      <!-- Status Filter -->
      <div class="col-6 col-md-2 col-lg-2">
        <select 
          class="form-select form-select-sm" 
          v-model="filters.status" 
          @change="applyFilters"
        >
          <option value="">{{ $t('attendance.allStatuses') }}</option>
          <option value="present">{{ $t('attendance.present') }}</option>
          <option value="absent">{{ $t('attendance.absent') }}</option>
          <option value="late">{{ $t('attendance.late') }}</option>
          <option value="excused">{{ $t('attendance.excused') }}</option>
          <option value="on_leave">{{ $t('attendance.onLeave') }}</option>
        </select>
      </div>
      
      <!-- Reset Button (Desktop) -->
      <div class="col-md-1 d-none d-md-block">
        <button 
          class="btn btn-outline-secondary btn-sm w-100" 
          @click="resetFilters"
          :title="$t('common.reset')"
        >
          <i class="fas fa-filter-circle-xmark"></i>
        </button>
      </div>
      
      <!-- Search Input -->
      <div class="col-12 col-md-3 col-lg-3 position-relative">
        <input
          type="text"
          class="form-control form-control-sm ps-5"
          :placeholder="$t('attendance.searchTeacher')"
          v-model="filters.search"
          @input="handleSearch"
          style="padding-right: 12px;" 
        />
        <span class="position-absolute start-0 top-50 translate-middle-y ps-3">
          <i class="fas fa-search"></i>
        </span>
      </div>
      
      <!-- Reset Button (Mobile) -->
      <div class="col-12 d-md-none">
        <button class="btn btn-outline-secondary btn-sm w-100" @click="resetFilters">
          <i class="fas fa-filter-circle-xmark"></i> {{ $t('common.reset') }}
        </button>
      </div>
      
      <!-- Add New Button -->
      <div class="col-12 col-md-2 col-lg-2">
        <router-link 
          to="/teacher-attendances/record" 
          class="btn btn-secondary btn-sm w-100"
          v-can="'teacher_attendance.create'"
        >
          <i class="fas fa-plus"></i>
          {{ $t('attendance.recordAttendance') }}
        </router-link>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, defineEmits } from 'vue';
import { debounce } from 'lodash';

const emit = defineEmits(['filter']);

const filters = ref({
  date: '',
  status: '',
  search: ''
});

const handleSearch = debounce(() => {
  applyFilters();
}, 300);

const applyFilters = () => {
  emit('filter', filters.value);
};

const resetFilters = () => {
  filters.value = {
    date: '',
    status: '',
    search: ''
  };
  emit('filter', filters.value);
};
</script>
